import Program from 'nanogl/program'

import gui from '@/webgl/dev/gui'
import { Gui } from '@/webgl/dev/gui/api'
import BaseEffect from '@/webgl/postprocess/effects/base-effect'

type TextureFilter = 'linear' | 'point'

export default class Pixelate extends BaseEffect {
  pixelSize: number = 1

  _pixelSize: number = 1
  _renderWidth: number = 1
  _renderHeight: number = 1
  _activeFilter: TextureFilter = 'linear'

  constructor() {
    super()
  }

  //#region GUI
  folder: Gui
  setupGUI(root: Gui) {
    this.folder = root ? root.folder('Pixelate') : gui.folder('Pixelate')
    this.folder.add(this, 'pixelSize', { min: 0, max: 100 })
  }
  //#endregion

  genCode(precode: string[], code: string[]): void {}

  init(): void {}

  release(): void {}

  setupProgram(prg: Program): void {}

  updateFilter() {
    if (this.pixelSize > 1 && this._activeFilter == 'linear') {
      this._activeFilter = 'point'
      this.post.mainColor.setFilter(false, false, false)
    }

    if (this.pixelSize <= 1 && this._activeFilter == 'point') {
      this._activeFilter = 'linear'
      this.post.mainColor.setFilter(this.post._needLinear(), this.post.mipmap, false)
    }
  }

  update(dt: number): void {
    this.pixelSize = Math.floor(Math.max(1, this.pixelSize))
    this.updateFilter()

    if (this._pixelSize != this.pixelSize) {
      this._pixelSize = this.pixelSize
      this.resize(this._renderWidth, this._renderHeight)
    }
  }

  preRender(): void {}

  resize(w: number, h: number): void {
    this._renderWidth = w
    this._renderHeight = h

    this.post.msaaFbo.setSize(this._renderWidth / this.pixelSize || 0, this._renderHeight / this.pixelSize || 0)
  }
}
